module.exports = "pegasus/assets/blocks/column-1-theme6.png";